/**
 * imageUrl — serve smaller images without re-uploading.
 *
 * Supabase Storage can resize/recompress images on the fly via its render endpoint, so we keep the
 * full-resolution original in the bucket and request a downscaled variant for on-screen display
 * (booklets, galleries). The PDF/export paths keep using the original URL.
 *
 * resizedImageUrl() rewrites a Supabase public OBJECT url:
 *   …/storage/v1/object/public/<bucket>/<path>
 * to its transform variant:
 *   …/storage/v1/render/image/public/<bucket>/<path>?width=…&quality=…&resize=contain
 *
 * Non-Supabase urls (legacy Airtable attachments, Drive links) are returned unchanged. The image
 * transformation feature is a Supabase paid-plan capability; if it's ever unavailable the render url
 * 403s, so consumers should onError-fallback to the original url (see RenderingBookViewer).
 */

const OBJECT_MARKER = '/storage/v1/object/public/'

export function resizedImageUrl(url, { width = 1600, quality = 75 } = {}) {
  if (!url || typeof url !== 'string') return url
  const i = url.indexOf(OBJECT_MARKER)
  if (i === -1) return url   // not a Supabase public-object url — leave as-is
  const base = url.slice(0, i)
  const path = url.slice(i + OBJECT_MARKER.length)
  const params = `width=${width}&quality=${quality}&resize=contain`
  return `${base}/storage/v1/render/image/public/${path}?${params}`
}

export default resizedImageUrl
